<template>
  <div class="report-detail">
    <iframe class="pdf" :src="pdfsrc" type="application/pdf" width="100%" height="100%"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdfsrc: ""
    };
  },
  created() {
    this.pdfsrc = sessionStorage.getItem("src");
  }
};
</script>

<style lang="scss" scoped>
.report-detail {
  height: 100vh;
}
</style>